import { c as _c } from "react/compiler-runtime";
import { AspectRatio, Avatar, Box, Card, HStack, Text } from '@chakra-ui/react';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { Article, ArticleType } from '@src/graphql-types';
import { useHover } from '@uidotdev/usehooks';
import moment from 'moment';
export type ArticleGridCardProps = {
  article: Article;
  baseUrl?: string;
};
export const ArticleGridCard = t0 => {
  const $ = _c(21);
  const {
    article,
    baseUrl
  } = t0;
  const [imageRef, hovering] = useHover();
  let href = `/articles'}/${article.slug}`;
  if (baseUrl) {
    href = `/${baseUrl}/${article.slug}`;
  } else {
    if (article.type === ArticleType.ExpertAdvice) {
      href = `/articles/${article.slug}`;
    } else {
      if (article.type === ArticleType.FounderStory) {
        href = `/founder-interviews/${article.slug}`;
      } else {
        if (article.type === ArticleType.Lexicon) {
          href = `/lexicon/${article.slug}`;
        }
      }
    }
  }
  const author = article.authors?.[0];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      background: "colorPalette.container",
      borderColor: "colorPalette.border",
      transform: "scale(1.01)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== article.featuredImage || $[2] !== hovering || $[3] !== imageRef) {
    t2 = article.featuredImage?.url && <AspectRatio overflow="hidden" ratio={1.7777777777777777} width="full"><Box ref={imageRef} background={`url('${article.featuredImage.url}') center/cover no-repeat`} height="full" transform={hovering ? "scale(1.05)" : undefined} transition="transform 0.2s ease-in" width="full" /></AspectRatio>;
    $[1] = article.featuredImage;
    $[2] = hovering;
    $[3] = imageRef;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== article.title) {
    t3 = <Card.Title lineClamp={2}>{article.title}</Card.Title>;
    $[5] = article.title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== article.seoDescription) {
    t4 = article.seoDescription && <Card.Description lineClamp={10}>{article.seoDescription}</Card.Description>;
    $[7] = article.seoDescription;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <Card.Body gap={3}>{t3}{t4}</Card.Body>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== article.originalPublicationDate || $[13] !== article.publishedAt || $[14] !== author) {
    t6 = (author || article.originalPublicationDate) && <Card.Footer><HStack gap={3} width="full">{author && <HStack flex={1} gap={2}><Avatar.Root size="xs"><Avatar.Fallback name={`${author.firstName} ${author.lastName}`} />{author.avatar?.url && <Avatar.Image src={author.avatar.url} />}</Avatar.Root><Text color="fg.muted" fontSize="xs" fontWeight={600}>{author.firstName} {author.lastName}</Text></HStack>}{(article.originalPublicationDate || article.publishedAt) && <Text color="fg.subtle" flexShrink={0} fontSize="xs">{moment(article.originalPublicationDate || article.publishedAt).format("MMM D, YYYY")}</Text>}</HStack></Card.Footer>;
    $[12] = article.originalPublicationDate;
    $[13] = article.publishedAt;
    $[14] = author;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== href || $[17] !== t2 || $[18] !== t5 || $[19] !== t6) {
    t7 = <Card.Root background="colorPalette.container/50" borderColor="colorPalette.border/25" overflow="hidden" transition="all 0.2s ease-in" _hover={t1}><NextLink href={href} prefetch={false}>{t2}{t5}{t6}</NextLink></Card.Root>;
    $[16] = href;
    $[17] = t2;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};